import React from 'react';
import styles from './LeftNav.module.css';
import { LeftNavLinks } from './LeftNavLinks';

const LeftNav = ({ section = "securities", activeTab, onTabClick }) => {
  const navItems = LeftNavLinks[section] || [];

  return (
    <div className={styles.leftNavWrapper}>
      <div className={styles.navList}>
        {navItems.map(({ label, key }) => (
          <div
            key={key}
            className={`${styles.link} ${activeTab === key ? styles.active : ''}`}
            onClick={() => onTabClick(key)}
          >
            {label}
          </div>
        ))}
      </div>
    </div>
  );
};

export default LeftNav;